import { biliBridge } from "@bilibili/js-bridge";

// 上报类型，需要与eventid 最后的 .show / .pv 对应，否则会崩！！
export const ReportEventType = {
  PV: 1, // 没有这个场景
  CLK: 2,
  SHOW: 3,
};

/**
 * 通过jsb上报埋点
 *
 * @param {*} spm
 * @param {*} type 1. pv 2. 点击 3. 曝光
 * @param {*} params
 */
export const reportEventJsb = (spm, type, params) => {
  biliBridge.callNative({
    method: "ability.reportEventV3",
    data: {
      event: spm,
      params: JSON.stringify(params),
      type, // 0: 其它，1: PV，2: 点击，3: 展现，4: 系统，5: 性能，7: 自定义，9: 播放器
      // label: 'webviewTracker', // 5.39新增, type为5时标识采用前端与客户端打通的性能上报
    },
    callback: () => {
      console.log("调用成功");
    },
  });
};
